import Pikaday from 'pikaday';
import moment from 'moment';

/**
 * Variables
 */

	// NOTE: These are NOT jQuery objects
	const
		$newsFilterForm            = document.getElementById( 'formNewsFilter' ),
		$newsFilterCustomDateRange = document.getElementById( 'newsFilterCustomDateRange' ),
		$newsFilterNetworkSelect   = document.getElementById( 'newsFilterNetworkSelect' ),
		$newsFilterPostType   = document.getElementById( 'newsFilterPostType' ),
		$newsFilterDateRangeSelect = document.getElementById( 'newsFilterDateRangeSelect' ),
		$newsFilterFormSubmit      = document.getElementById( 'newsFilterFormSubmit' ), // Submit button. Only appears when custom date range used
		$sectionPressReleases      = document.getElementById( 'section-press-releases' ),
		$pressReleaseFilterToggle = document.getElementById( 'press--release_filter' ),
		$sectionContent            = document.getElementById( 'sectionContent' ),
		$sectionResults            = document.getElementById( 'sectionResults' );

	let
		pushID       = 0,
		isPop        = false, // track if the onpopstate has fired
		loading      = false,
		networks     = [],
		postTypes = [],
		globalParams = null;

/**
 * Utility
 */

	/**
	 * Takes an array and returns array of key/value pairs for the data.
	 *
	 * @param {Element} form Form element to get data from.
	 */
	// erik b: parses filter form for values
	const serializeArray = function( form ) {
		let
			field,
			l,
			j,
			s = [];

		//if ( 'paramsect' === typeof form && 'FORM' === form.nodeName ) { // erik b : No idea what paramsect was supposed to be used for. No such type.
		if ( 'FORM' === form.nodeName ) {
			let len = form.elements.length;
			for ( let i = 0; i < len; i++ ) {
				field = form.elements[i];

				if ( field.name && ! field.disabled && 'file' !== field.type && 'reset' !== field.type && 'submit' !== field.type && 'button' !== field.type ) {
					if ( 'select-multiple' === field.type ) {
						l = form.elements[i].options.length;
						for ( j = 0; j < l; j++ ) {
							if ( field.options[j].selected ) {
								s[s.length] = {name: field.name, value: field.options[j].value};
							}
						}
					} else if ( ( 'checkbox' !== field.type && 'radio' !== field.type ) || field.checked ) {
						s[s.length] = {name: field.name, value: field.value};
					}
				}
			}
		} else {
			console.error( 'No FORM passed to serializeArray' );
		}

		return s;
	};

	// get News page filter options
	const getParams = function() {
		const defaults = {
			'network': '0',
			'date-range': '',
			'post_type': '0',
			'custom-start-date': '',
			'custom-end-date': '',
			'page': 1
		};

		let params  = {};
		let data    = serializeArray( $newsFilterForm );
		let paged   = 1;
		let queries = ( -1 < window.location.href.indexOf( '?' ) ) ? window.location.href.slice( window.location.href.indexOf( '?' ) + 1 ).split( '&' ) : false;

		console.log( 'data=', data );
		console.log( 'queries=', queries );

		if ( ! isPop ) { //erik b: I only see isPop set to false
			console.log( '--- !isPop ---' );
			paged = parseInt( $newsFilterForm.getAttribute( 'data-paged' ) );

			for ( let index = 0; index < data.length; index++ ) {
				const object = data[index];
				const name = object.name;
				const value = object.value;

				params[name] = value;
			}

			params.page = paged;
		} else if ( isPop && queries ) {
			console.log( '--- isPop && queries---' );
			paged = window.location.href.match( /\/page\/(\d+)\// );

			for ( let index = 0; index < queries.length; index++ ) {
				const query = queries[index];
				const pair  = query.split( '=' );
				const name  = pair[0];
				const value = pair[1];

				params[name] = value;
			}

			params.page = ( null === paged ) ? 1 : paged[1];
		} else if ( isPop && ! queries ) {
			console.log( '--- isPop && !queries---' );
			paged = window.location.href.match( /\/page\/(\d+)\// );

			params.page = ( null === paged ) ? 1 : paged[1];
		}

		// params replaces defaults
		globalParams = Object.assign({}, defaults, params );

		console.log( 'globalParams = ', globalParams );

		return globalParams;
	};

	const getOptions = function() {
		const options = {
			'per_page': 10
		};
		const params = getParams();

		const brand = networks.find( ( element ) => {
			return ( element.slug === params.network );
		});

		const type = postTypes.find( ( element ) => {
			return ( element.slug === params.post_type );
		});

		const range = params['date-range'];

		let after = '';
		let before = '';

		console.log( 'networks=', networks );
		console.log( 'brand = ', brand );
		console.log( 'post_type = ', type );
		console.log( 'range = ', range );

		// Set the brands
		if ( '0' !== params.network ) {
			options.brands = [ brand.id ];
		}

		if ( '0' !== params.post_type ) {
			// eslint-disable-next-line
			options.release_post_types = [ type.id ];
		}

		if ( '' !== range ) {
			if ( 'cur-month' === range ) {
				after = moment().startOf( 'month' );
				console.log( 'cur-month after = ', after );
			} else if ( 'past-six-months' === range ) {
				after = moment().subtract( 6, 'months' );
				console.log( 'six-months after = ', after );
			} else if ( 'past-year' === range ) {
				after = moment().subtract( 1, 'year' );
				console.log( 'past-year after = ', after );
			} else if ( 'custom' === range ) {

				// Protect against blank entries
				if ( '' === params['custom-start-date']) {
					params['custom-start-date'] = moment().startOf( 'year' ).format( 'YYYY-MM-DD' );
				}
				if ( '' === params['custom-end-date']) {
					params['custom-end-date'] = moment().endOf( 'date' ).format( 'YYYY-MM-DD' );
				}

				// Correct Dates if start & end are in wrong order
				if ( params['custom-start-date'] > params['custom-end-date']) {
					let tempDateHold = params['custom-start-date'];
					params['custom-start-date'] = params['custom-end-date'];
					params['custom-end-date'] = tempDateHold;

					// reset form values in proper order
					let $tempDateHold = document.getElementById( 'newsFilterStartDateInput' ).value;
					document.getElementById( 'newsFilterStartDateInput' ).value = document.getElementById( 'newsFilterEndDateInput' ).value;
					document.getElementById( 'newsFilterEndDateInput' ).value = $tempDateHold;
				}

				after = moment( params['custom-start-date']);
				before = moment( params['custom-end-date']);

				console.log( 'custom after = ', after );
				console.log( 'custom before = ', before );
			} else {
				console.error( 'Unknown Date Range' );
			}
		} else {
			console.log( 'No Date Range' );
		}

		if ( '' !== after ) {
			options.after = after.toISOString();
		}
		if ( '' !== before ) {
			options.before = before.endOf( 'day' ).toISOString(); // Needs endOf so selected date is captured in API ajax call
		}
		console.log( 'Options Returned = ', Object.assign({}, options, params ) );
		return Object.assign({}, options, params );
	};

	const getBrands = function() {
		const options = {
			'per_page': 100
		};
		const done = ( response ) => {
			networks = response;

			//After upload branch we have to upload all post type
			loading = false;
			getPostType();
		};

		restRequest( 'wp/v2/brands', options, done );
	};

	const getPostType = function() {
		const options = {
			'per_page': 100
		};
		const done = ( response ) => {
			postTypes = response;
		};
		restRequest( 'wp/v2/release_post_types', options, done );
	};

	const createPagination = function( totalPages = 0 ) {
		const $pagination = document.querySelectorAll( '.pagination' );
		const params = getParams();
		const current = parseInt( params.page );
		const endsize = 1;
		const midsize = 4;

		const origin = window.location.protocol + '//' + window.location.hostname + ( window.location.port ? ':' + window.location.port : '' );

		let dots = false;
		let pageLinks = [];
		let HTML = '';

		// Check if there are 10 posts or less.
		if ( 2 > totalPages ) {
			jQuery( $pagination ).addClass( 'pagination--hide' );
		} else {
			jQuery( $pagination ).removeClass( 'pagination--hide' );
			if ( current && 1 < current ) {
				pageLinks.push( `<a class='page-numbers' href='${origin}/news/page/1/'>«</a>` );
				pageLinks.push( `<a class='page-numbers' href='${origin}/news/page/${current - 1}/'>«</a>` );
			}

			for ( let index = 1; index <= totalPages; index++ ) {
				if ( index === current ) {
					pageLinks.push( `<span class='page-numbers current'>${index}</span>` );
					dots = true;
				} else {
					if (
						( index <= endsize ||
						( current && index >= current - midsize && index <= current + midsize ) ||
						index > totalPages - endsize )
					) {
						pageLinks.push( `<a class='page-numbers' href='${origin}/news/page/${index}/'>${index}</a>` );
						dots = true;
					} else if ( dots ) {
						pageLinks.push( '<span class="page-numbers dots">&hellip;</span>' );
						dots = false;
					}
				}
			}

			if ( current < totalPages ) {
				pageLinks.push( `<a class='page-numbers' href='${origin}/news/page/${current + 1}/'>»</a>` );
				pageLinks.push( `<a class='page-numbers' href='${origin}/news/page/${totalPages}/'>»</a>` );
			}
		}

		HTML += '<li>';
		HTML += pageLinks.join( '</li>\n\t<li>' );

		jQuery( '.pagination' ).html( '<ul class="pagination__links">' + HTML + '</ul>' );
	};

	const restRequest = function( endpoint = '', options = {}, done = () => {}, fail = () => {}) {

		if ( loading ) {
			return;
		}
		console.log( 'restRequest Options=', options );

		// Set loading
		loading = true;
		$sectionPressReleases.classList.add( 'section--news-is-loading' );
		$sectionContent.setAttribute( 'aria-busy', true );

		jQuery.ajax({
			url: `${window.amcn_localized.wp_rest}${endpoint}`,
			type: 'GET',
			data: options,
			dataType: 'json'
		})
		.done( done )
		.fail( fail )
		.always( () => {

			// Unset loading
			$sectionPressReleases.classList.remove( 'section--news-is-loading' );
			loading = false;
			$sectionContent.setAttribute( 'aria-busy', false );
		});
	};

	const postsAjaxDone = function( response, textStatus, jqXHR ) {

		const totalPosts = parseInt( jqXHR.getResponseHeader( 'X-WP-Total' ) );
		const totalPages = parseInt( jqXHR.getResponseHeader( 'X-WP-TotalPages' ) );

		var $container = $sectionResults.querySelector( '.section__results' );
		var HTML = '';

		// Show the proper section
		if ( 0 < response.length ) {
			$sectionPressReleases.classList.remove( 'section--news-no-results' );
			$sectionPressReleases.classList.add( 'section--news-results' );

			for ( let index = 0; index < response.length; index++ ) {
				const article = response[index];

				HTML += article.rendered;
			}
		} else {
			$sectionPressReleases.classList.remove( 'section--news-results' );
			$sectionPressReleases.classList.add( 'section--news-no-results' );
		}
		if ( '' !== HTML ) {
			$container.innerHTML = HTML;
		}

		createPagination( totalPages );
		updateURL();
		updateFilter();
	};

	const selectIsCustomDate = function() {
		const value = $newsFilterDateRangeSelect.value;

		return ( 'custom' === value );
	};

	const selectDateCheckA11y = function() {
		if ( selectIsCustomDate() ) {
			jQuery( $newsFilterForm ).addClass( 'custom-range' );
		} else {
			jQuery( $newsFilterForm ).removeClass( 'custom-range' );
		}
	};

	const sectionContentSetupA11y = function() {
		$sectionContent.setAttribute( 'aria-live', 'polite' );
		$sectionContent.setAttribute( 'aria-atomic', true );
	};

	const formA11y = function() {
		$newsFilterForm.setAttribute( 'aria-controls', 'sectionContent' );
	};

	const updateURL = function() {
		const
			params = getParams(),
			page   = params.page,
			origin = window.location.protocol + '//' + window.location.hostname + ( window.location.port ? ':' + window.location.port : '' );

		let url = origin + '/news/';

		delete params.page;

		if ( 1 < page ) {
			url += 'page/' + page + '/';
		}

		url += '?' + jQuery.param( params );

		if ( ! isPop ) {
			history.pushState({ url: url, id: pushID }, '', url );
		}
	};

	const updateFilter = function() {
		if ( ! isPop ) {
			return;
		}

		for ( const param in globalParams ) {
			if ( globalParams.hasOwnProperty( param ) ) {
				const name = param;
				const value = globalParams[param];

				jQuery( `[name="${name}"]` ).val( value );
			}
		}

		selectDateCheckA11y();
	};

	/**
	 * Adds Pikaday date picking fallback for browsers without a native one.
	 */
	const setupDatePickerFallback = function() {
		const
			$inputs = $newsFilterCustomDateRange.querySelectorAll( 'input' );

		// Use modernizr to check support.
		// Exit if there is a native date picker.
		if ( Modernizr.inputtypes.date ) {
			return;
		}

		// Loop through inputs and add a date picker.
		for ( let index = 0; index < $inputs.length; index++ ) {
			const $element = $inputs[index];

			let picker = new Pikaday({
				field: $element,
				format: 'YYYY-MM-DD'
			});
		}
	};

/**
 * Events
 */

	const windowPopstate = function( event ) {
		const options = getOptions();

		isPop = true;

		// Make request
		restRequest( 'wp/v2/posts', options, postsAjaxDone );
	};

	const formSubmit = function( event ) {
		const options = getOptions();

		// Reset page to 1
		// Else error occurs when
		if ( 'custom' === options['date-range']) {
			options.page = 1;
			$newsFilterForm.setAttribute( 'data-paged', 1 );
		}

		console.log( 'formSubmit options = ', options );

		event.preventDefault();

		isPop = false;
		pushID = pushID + 1;

		// Make request
		restRequest( 'wp/v2/posts', options, postsAjaxDone );
	};

	const paginationClick = function( event ) {
		const
			href = jQuery( this ).attr( 'href' ),
			page = href.match( /\/page\/(\d+)\// ),
			paged = parseInt( page[1]) || 1;

		event.preventDefault();

		isPop = false;
		pushID = pushID + 1;

		$newsFilterForm.setAttribute( 'data-paged', paged );

		let options = getOptions();

		// Make request
		restRequest( 'wp/v2/posts', options, postsAjaxDone );
	};

	const selectNetworkChange = function() {
		$newsFilterForm.setAttribute( 'data-paged', 1 );

		// set new network
		jQuery( $newsFilterForm ).submit();
	};

	const selectPostType = function() {
		$newsFilterForm.setAttribute( 'data-paged', 1 );

		// set new network
		jQuery( $newsFilterForm ).submit();
	};

	const selectDateRangeChange = function() {

		selectDateCheckA11y();

		if ( ! selectIsCustomDate() ) {
			$newsFilterForm.setAttribute( 'data-paged', 1 );

			// set new date range
			jQuery( $newsFilterForm ).submit();
		}
	};

	/**
	 * $pressReleaseFilterToggle
	 */
	const pressReleaseFilterToggle =  function() {
		jQuery( $pressReleaseFilterToggle ).on( 'click', function() {
			jQuery( $newsFilterForm ).toggleClass( 'show' );
		});
	};

/**
 * Public
 */
	const newsFilterInit = function() {

		// Exit if the template is not news.
		if ( ! document.querySelector( 'body' ).classList.contains( 'page-template-news' ) ) {
			return;
		}

		pressReleaseFilterToggle();

		// Setup
		getBrands();

	// a11y
		formA11y();
		sectionContentSetupA11y();
		selectDateCheckA11y(); // Will set a11y for hidden depending on value.
		$newsFilterDateRangeSelect.setAttribute( 'aria-controls', 'newsFilterCustomDateRange' );

		// Binding
		jQuery( $newsFilterForm ).on( 'submit', formSubmit );
		jQuery( $newsFilterDateRangeSelect ).on( 'change', selectDateRangeChange );
		jQuery( $newsFilterNetworkSelect ).on( 'change', selectNetworkChange );
		jQuery( $newsFilterPostType ).on( 'change', selectPostType );
		jQuery( $sectionContent ).on( 'click', '.pagination a', paginationClick );
		jQuery( window ).on( 'popstate', windowPopstate );

		// Date picker
		setupDatePickerFallback();

		$newsFilterForm.classList.add( 'form--news-filter-js' );
	};

export { newsFilterInit };
